import React from 'react';
import styles from './Dialog.module.css';

export default function Dialog({ open, onClose, title, children, actions }) {
  if (!open) return null;
  return (
    <div className={styles.dialogOverlay}>
      <div className={styles.dialogBox}>
        <div className={styles.dialogHeader}>
          <h3 className={styles.dialogTitle}>{title}</h3>
          <button className={styles.dialogClose} onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className={styles.dialogContent}>{children}</div>
        {actions && <div className={styles.dialogActions}>{actions}</div>}
      </div>
    </div>
  );
} 